import * as React from "react";
import { cn } from "../../lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/**
 * Textarea — Clones Design System (ADR-0030).
 *
 * Same surface/ring tokens as Input. Keeps `.ru-text` so multi-line Russian
 * prose lands on the Cyrillic-tuned line-height.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      data-cds-textarea
      className={cn(
        "flex min-h-[max(4rem,calc(80px*var(--d)))] w-full rounded-[var(--r-3)] border border-[var(--border-control)] bg-[var(--paper-2)] px-[var(--field-padding-x)] py-[var(--field-padding-y)] text-[length:var(--field-font-size)] text-[var(--ink)]",
        "placeholder:text-[var(--ink-4)]",
        "aria-[invalid=true]:border-[var(--bad)] aria-[invalid=true]:ring-[var(--bad)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--pulse)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--paper)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "resize-y ru-text",
        "[@media(any-pointer:coarse)]:text-[16px] [@media(max-width:639px)]:text-[16px]",
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";

export { Textarea };
